import React, { useEffect, useState } from 'react'
import { Select, message as $message } from 'antd'
import { getModifyAreaList } from '@/services/supplier'

export default ({ value, type, onChange, ...restProps }) => {
    const [options, setOptions] = useState([])

    const load = async () => {
        const { success, message, data } = await getModifyAreaList()
        if (success) {
            setOptions(data.map(v => ({ label: v, value: v })))
        } else {
            $message.error(message)
        }
    }

    useEffect(() => {
        load()
    }, [])

    return (
        <Select
            showSearch
            allowClear
            mode="multiple"
            value={value}
            onChange={onChange}
            maxTagCount="responsive"
            filterOption={(input, option) => {
                try {
                    return option?.label?.toLowerCase?.()?.indexOf(input?.toLowerCase?.()) >= 0
                } catch (error) {
                    console.error('catchError', error)
                    return true
                }
            }}
            options={options}
            {...restProps}
        />
    )
}
